import { UserResponse } from '@pb/mocks'
import { request } from '@pb/utils'
import { Settings } from './duck/types/settings'
import { getReactLocale } from 'helpers/getReactLocale'

const fetchSettings = (): Promise<Settings> => {
  const localeToUse = getReactLocale()
  return request.get(`settings/${localeToUse}`, { apiVersion: 2 }).then((res) => res.data)
}

// For testing:
// Use /user?status=NON_MEMBER as url to get a non club member result
// Use /user?status=PENDING as url to get a pending member result
// Use testWithQR instead of userParams to get a QR code instead of a barcode
// const testWithQR = `?codeType=qr`

const errorParam = localStorage.getItem('hmError') ? `error=${localStorage.getItem('hmError')}` : ''

const userStatusParam = localStorage.getItem('hmUserStatus')
  ? `status=${localStorage.getItem('hmUserStatus')}`
  : ''

const customerTypeParam = localStorage.getItem('hmCustomerType')
  ? `customerType=${localStorage.getItem('hmCustomerType')}`
  : ''

const userParams = __DEMO_OR_DEV__
  ? `?${[userStatusParam, customerTypeParam, errorParam]
      .filter((entry) => entry.includes('='))
      .join('&')}`
  : ''

const fetchUser = async (): Promise<UserResponse> => {
  const { data } = await request.get(`user${userParams}`, { apiVersion: 2 })
  return data
}

const fetchConfig = async (locale): Promise<UserResponse> => {
  const { data } = await request.get(`/api/config/v1/${locale}.json`, {
    use: {
      apiVersion: false,
      locale: false,
    },
  })
  return data
}

export default {
  fetchSettings,
  fetchUser,
  fetchConfig,
}
